// Leesona M50 Winder
import React from "react";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import { CommonRows, InputRangeRow, MinMaxRow, RadioButtonRow, RadioLabelCol, RunTimeRow, WindingTensionRow } from "./index";

export default function MachineLeesonaM50() {
   const { machineSetup } = useMachineSetupContextState();
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999} //some default value
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999"}
            floatProp={false}
         />
         <RunTimeRow />
         <WindingTensionRow windingTension />
         <MinMaxRow
            titleProp={"Back Press"}
            descriptionProp="kg"
            minProp1={0.0}
            maxProp1={10.0}
            floatProp1={true}
            errorProp1={"0.00-10.00 only"}
            minProp2={0.0}
            maxProp2={10.0}
            floatProp2={true}
            errorProp2={"0.00-10.00 only"}
            valueProp1={"backPressMin"}
            valueProp2={"backPressMax"}
         />
         <InputRangeRow
            titleProp={"Counter Scale Factor"}
            descriptionProp={""}
            sizeProp={4}
            typeProp={"text"}
            minProp={0.0}
            maxProp={999999} //some default value
            propertyNameProp={"scaleFactor"}
            errorDialogueProp={"Cannot be left empty"}
            floatProp={true}
            readOnlyProp={true}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"Drive Type"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"driveTypeGroup"}
               valueProp={"true"}
               onChangeProp={"gearDriven"}
               displayProp={"Gear Driven"}
               trueFalseProp
            />
            <RadioLabelCol
               groupNameProp={"driveTypeGroup"}
               valueProp={"false"}
               onChangeProp={"gearDriven"}
               displayProp={"Belt Driven"}
               trueFalseProp
            />
         </RadioButtonRow>
         {(machineSetup.extendedPropertyJson?.gearDriven === "true" || machineSetup.extendedPropertyJson?.gearDriven === true) && (
            <>
               <InputRangeRow
                  titleProp={"Spindle Gear"}
                  descriptionProp={""}
                  sizeProp={4}
                  typeProp={"text"}
                  minProp={20}
                  maxProp={102} //some default value
                  propertyNameProp={"gearSpindle"}
                  errorDialogueProp={"20-102 only"}
                  floatProp={false}
               />
               <InputRangeRow
                  titleProp={"Intermediate Gear"}
                  descriptionProp={""}
                  sizeProp={4}
                  typeProp={"text"}
                  minProp={20}
                  maxProp={102} //some default value
                  propertyNameProp={"gearIntermediate"}
                  errorDialogueProp={"20-102 only"}
                  floatProp={false}
               />
               <MinMaxRow
                  titleProp={"Gainer Gear"}
                  descriptionProp=""
                  minProp1={20}
                  maxProp1={102}
                  floatProp1={false}
                  errorProp1={"20-102 only"}
                  minProp2={20}
                  maxProp2={102}
                  floatProp2={false}
                  errorProp2={"20-102 only"}
                  valueProp1={"gearInnerGainer"}
                  valueProp2={"gearOuterGainer"}
                  differentDisplayProp1={"Inner:"}
                  differentDisplayProp2={"Outer:"}
               />
               <InputRangeRow
                  titleProp={"Cam Gear"}
                  descriptionProp={""}
                  sizeProp={4}
                  typeProp={"text"}
                  minProp={20}
                  maxProp={102}
                  propertyNameProp={"gearCam"}
                  errorDialogueProp={"20-102 only"}
                  floatProp={false}
               />
            </>
         )}
         <CommonRows />
      </>
   );
}
